import type { VoidComponent } from "solid-js";
import { For } from "solid-js";
import type { RegisterableHotkey } from "@tanstack/solid-hotkeys";
import { Kbd } from "./Kbd.tsx";

type KbdHintProps = {
  hotkeys: RegisterableHotkey | RegisterableHotkey[];
  label: string;
};

export const KbdHint: VoidComponent<KbdHintProps> = (props) => {
  const hotkeys = () => (Array.isArray(props.hotkeys) ? props.hotkeys : [props.hotkeys]);

  return (
    <div class="flex items-center gap-1.5 pointer-coarse:hidden">
      <div class="flex gap-1">
        <For each={hotkeys()}>{(hotkey) => <Kbd hotkey={hotkey} />}</For>
      </div>
      <span class="text-small-regular text-secondary lowercase">{props.label}</span>
    </div>
  );
};
